export class DateUtilities {



    public static UnixToDate(unix:number,offset:number=0)
    {
        if(unix!=null)
        {
            let date=new Date((unix+offset)*1000);
            date=new Date(date.setMinutes(date.getMinutes()+date.getTimezoneOffset()));
            return date;
        }else
            return null;
    }

    public static DateToUnix(date:Date,offset=0)
    {
        return ((date.getTime()-offset)/1000)+(date.getTimezoneOffset()*-1*60);
    }
}

